// extracted by mini-css-extract-plugin
module.exports = {"forWhomBlock":"ForWhomBlock_forWhomBlock__Wfupg","forWhomBlock_img":"ForWhomBlock_forWhomBlock_img__XpcWt","forWhomBlock_text":"ForWhomBlock_forWhomBlock_text__THStQ"};